import opsHubLogo from 'react-scale/corp/views/CorpProjectGroupManager/views/Home/techonology-3d.png';
import { twMerge } from 'tailwind-merge';
import { imageImportSrc } from 'lib/imageImportSrc';

export const GenAIOpsHubLogo = ({
  className,
  logoImg = opsHubLogo,
  alt = 'ops-hub-logo',
}: {
  className?: string;
  logoImg?: string | StaticImageData;
  alt?: string;
}) => {
  return <img src={imageImportSrc(logoImg)} alt={alt} className={twMerge('h-4/5', className)} />;
};
